// TreeSidebar.jsx              ліва панель з коренями/папками

import React from 'react';
import PropTypes from 'prop-types';
import FolderNode from './FolderNode';

export default function TreeSidebar({
    roots,
    tree,
    expanded,
    flatMode,
    setFlatMode,
    toggleNode,
    ensureChildren,
    onEnter,
    onOpenItem,
}) {

    return (
        <aside className="md:col-span-1 border rounded-lg p-3 max-h-[70vh] overflow-auto">
            <h3 className="font-semibold mb-2">Усі диски</h3>
            {/* Вмикач плоского перегляду */}
            <label className="flex items-center gap-2 text-xs cursor-pointer">
                <input
                    type="checkbox"
                    className="accent-black"
                    checked={flatMode}
                    onChange={(e) => setFlatMode(e.target.checked)}
                    title="Плоский перегляд: відкривати всі файли рекурсивно"
                />
                <span>Плоский перегляд</span>
            </label>
            <ul className="space-y-1">
                {roots.map(root => (
                    <li key={root.id}>
                        <FolderNode
                            id={root.id}
                            name={root.name}
                            icon={root.icon}
                            tree={tree}
                            expanded={expanded}
                            toggleNode={toggleNode}
                            ensureChildren={ensureChildren}
                            onEnter={onEnter}
                            onOpen={(i, kind, nodes) => onOpenItem(i, kind, nodes)}
                        />
                    </li>
                ))}
            </ul>
        </aside>
    );
}

TreeSidebar.propTypes = {
    roots: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
    })).isRequired,
    tree: PropTypes.object.isRequired,
    expanded: PropTypes.object.isRequired,
    flatMode: PropTypes.bool.isRequired,
    setFlatMode: PropTypes.func.isRequired,
    toggleNode: PropTypes.func.isRequired,
    ensureChildren: PropTypes.func.isRequired,
    onEnter: PropTypes.func.isRequired,
    onOpenItem: PropTypes.func.isRequired,
};
